import React from 'react';
export function FeatureBand() {
  return <section aria-label="Finish detail" className="relative isolate w-full overflow-hidden bg-pine-950" data-id="element-103" data-mp="32ue68moffpgj">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/1b0f973c-95d3-44a8-a381-d87ef7e49bd9.jpg" alt="Remodeled primary bathroom with a freestanding tub, marble tile, oak vanity, and matte black fixtures" className="h-[60vh] min-h-[420px] w-full object-cover" data-id="element-104" data-mp="fo7ji3l2t4ky" />
      <div className="absolute inset-0 bg-pine-950/55" aria-hidden="true" data-id="element-105" data-mp="yl8qfty6xerj" />
      <div className="absolute inset-0 flex items-end" data-id="element-106" data-mp="yj5rgkf28bao">
        <div className="mx-auto w-full max-w-[1320px] px-6 pb-12 sm:pb-16 lg:px-10" data-id="element-107" data-mp="13d09ljf0oi7n">
          <p className="max-w-2xl font-display text-2xl font-light leading-snug text-bone-50 sm:text-4xl" data-id="element-108" data-mp="18bbjtv984uqe">
            The difference shows up in the details — tile layout, cabinet
            reveals, and finishes that still look right ten years from now.
          </p>
          <p className="mt-5 text-[11px] uppercase tracking-widest2 text-bone-100/55" data-id="element-109" data-mp="16f20sq42p4or">
            Primary bath · Interior remodel
          </p>
        </div>
      </div>
    </section>;
}